import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
export const isPrerendering = () => {
    return rootRoutes.constants.isPrerendering.check(new URLSearchParams(window.location.search));
};
//# sourceMappingURL=isPrerendering.js.map